import c from "./index.es473.js";
function o(n) {
  return Object.keys(n).map(function(t) {
    return "".concat(t, '="').concat(c(String(n[t])), '"');
  }).reduce(function(t, r) {
    return t + " " + r;
  }, "");
}
export {
  o as default
};
//# sourceMappingURL=index.es520.js.map
